export const WHATSAPP_PHONE = '+34 641 482 189'

export const WHATSAPP_URL =
  'https://wa.me/34641482189?text=Hola%20Lussonovo%2C%20quiero%20presupuesto%20para%20cambiar%20el%20suelo%20de%20mi%20vivienda.'

export const SOCIAL_LINKS = [
  {
    name: 'Instagram',
    handle: '@lussonovo',
    url: 'https://www.instagram.com/lussonovo/',
  },
  {
    name: 'TikTok',
    handle: '@lussonovo',
    url: 'https://www.tiktok.com/@lussonovo',
  },
  {
    name: 'YouTube',
    handle: '@lussonovo',
    url: 'https://www.youtube.com/@lussonovo',
  },
  {
    name: 'Facebook',
    handle: 'Lussonovo',
    url: 'https://www.facebook.com/profile.php?id=61576955340559',
  },
] as const

export const GOOGLE_REVIEWS_URL = 'https://share.google/xj1UZrhSryvUhdCzX'

/** Reseñas reales publicadas en el perfil de Google de Lussonovo. */
export const GOOGLE_REVIEWS = [
  {
    name: 'José Ariel Veloso',
    initials: 'JV',
    date: 'Hace una semana',
    badge: null as string | null,
    rating: 5,
    text: 'Nos han cambiado el parquet de todo el piso y el trabajo ha sido excelente. Destaco sobre todo el cuidado y nivel de detalle.',
  },
  {
    name: 'Hernán Perea',
    initials: 'HP',
    date: 'Hace una semana',
    badge: 'Local Guide · 24 opiniones',
    rating: 5,
    text: 'Agustín estuvo excelente: fue súper ordenado, profesional y rápido. Me solucionó un problemón. Muchas gracias!!',
  },
  {
    name: 'Emiliano Terranova',
    initials: 'ET',
    date: 'Hace una semana',
    badge: 'Local Guide · 17 opiniones',
    rating: 5,
    text: 'El servicio que prestó Agustín fue excelente! Ordenado, limpio, prolijo y súper profesional. Nos realizó un cambio de parquet y quedó perfecto!',
  },
  {
    name: 'Pau Guallar',
    initials: 'PG',
    date: 'Hace 11 meses',
    badge: null as string | null,
    rating: 5,
    text: 'Muy buen trabajo de Agustín y Gerardo que nos pintaron y pusieron el parquet y los rodapiés en nuestro nuevo piso, que le ha dado energía nueva. También queremos destacar la muy buena comunicación y disponibilidad de Agustín para resolver nuestras dudas y poder coordinarnos en los tiempos. ¡Gracias por vuestro trabajo!',
  },
]

export const NAV_LINKS = [
  { label: 'El sistema', href: '#sistema' },
  { label: 'Calculadora', href: '#calculadora' },
  { label: 'Tipos de suelo', href: '#suelos' },
  { label: 'Proceso', href: '#proceso' },
  { label: 'Proyectos', href: '#proyectos' },
  { label: 'FAQ', href: '#faq' },
]

export const TRUST_POINTS = [
  {
    title: 'Especialistas en pavimentos',
    text: 'Parquet, laminado y vinílico SPC en viviendas de Barcelona.',
  },
  {
    title: 'Presupuesto cerrado',
    text: 'Revisión técnica antes de empezar. Sin extras improvisados.',
  },
  {
    title: 'Obra planificada',
    text: 'Fases, accesos y protección definidos desde el primer día.',
  },
  {
    title: 'Acabado revisado',
    text: 'Rodapiés, juntas, perfiles y puertas antes de entregar.',
  },
]

export const PROBLEM_CARDS = [
  {
    title: 'Presupuestos poco claros',
    text: 'No sabes qué incluye realmente ni qué se cobrará aparte.',
  },
  {
    title: 'Rodapiés y puertas sin resolver',
    text: 'El suelo queda nuevo, pero los detalles arruinan el resultado final.',
  },
  {
    title: 'Obra desordenada',
    text: 'Polvo, muebles mal protegidos y falta de comunicación.',
  },
  {
    title: 'Material mal elegido',
    text: 'No todos los suelos sirven para todas las viviendas, usos o niveles de humedad.',
  },
  {
    title: 'Remates pendientes',
    text: 'Juntas, perfiles, cortes y encuentros que quedan “para luego”.',
  },
]

export const PILLARS = [
  {
    index: '01',
    title: 'Diagnóstico antes de venderte nada',
    text: 'Revisamos metros, estado del suelo actual, puertas, rodapiés, desniveles, humedad y tipo de uso de la vivienda.',
  },
  {
    index: '02',
    title: 'Instalación planificada',
    text: 'Organizamos materiales, tiempos, accesos, protección de zonas y fases de trabajo para reducir imprevistos.',
  },
  {
    index: '03',
    title: 'Acabado completo',
    text: 'No nos vamos dejando el suelo “casi terminado”. Cuidamos rodapiés, cortes, juntas, puertas y remates visibles.',
  },
]

export const FLOOR_TYPES = [
  {
    name: 'Laminado premium',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/21252d4c-ff9f-4eeb-b559-19800b27e6d3.jpg',
    text: 'Ideal si buscas buena estética, resistencia y una instalación rápida con excelente relación calidad-precio.',
    perfect:
      'Viviendas familiares, pisos de alquiler, dormitorios, salones y reformas rápidas.',
  },
  {
    name: 'Vinílico / SPC',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/e8519ace-cdf9-4d60-b4e6-9f833870b389.jpg',
    text: 'Muy resistente al agua y al uso diario. Una opción práctica para zonas de alto tránsito o viviendas donde buscas máxima durabilidad.',
    perfect: 'Cocinas, baños, alquileres, mascotas y viviendas con mucho movimiento.',
  },
  {
    name: 'Parquet / madera natural',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/eacfc078-2886-43e0-8263-a1825ff49b52.jpg',
    text: 'La opción más cálida, elegante y premium. Un suelo con carácter, textura y presencia real.',
    perfect:
      'Viviendas principales, pisos de alto valor, reformas con diseño e interiores sofisticados.',
  },
]

export const INCLUDED_ITEMS = [
  'Asesoría de material',
  'Medición y revisión técnica',
  'Planificación de instalación',
  'Preparación del soporte',
  'Instalación profesional',
  'Rodapiés y perfiles',
  'Ajuste de puertas',
  'Limpieza y entrega final',
]

export const COMPARISON_ROWS = [
  {
    traditional: 'Precio inicial poco claro.',
    lussonovo: 'Estimación inicial y presupuesto cerrado.',
  },
  {
    traditional: 'Se habla solo del material.',
    lussonovo: 'Diagnóstico del estado real del piso.',
  },
  {
    traditional: 'Rodapiés y puertas se deciden después.',
    lussonovo: 'Rodapiés, puertas y remates previstos.',
  },
  {
    traditional: 'La obra avanza con improvisaciones.',
    lussonovo: 'Trabajo planificado por fases.',
  },
  {
    traditional: 'El cliente persigue respuestas.',
    lussonovo: 'Comunicación directa.',
  },
  {
    traditional: 'El resultado depende del instalador del día.',
    lussonovo: 'Acabado final revisado antes de entregar.',
  },
]

export const PROCESS_STEPS = [
  {
    title: 'Calculas o nos envías medidas',
    text: 'Con la calculadora o una foto por WhatsApp tenemos el punto de partida.',
  },
  {
    title: 'Te orientamos sobre el material',
    text: 'Laminado, vinílico o madera según uso, humedad y estética de tu vivienda.',
  },
  {
    title: 'Revisamos puntos críticos',
    text: 'Desniveles, humedad, puertas, rodapiés, accesos y encuentros con otras estancias.',
  },
  {
    title: 'Te enviamos presupuesto cerrado',
    text: 'Detallado por partidas, sin extras sorpresa al final de la obra.',
  },
  {
    title: 'Planificamos la instalación',
    text: 'Fechas, fases, protección de zonas y logística de materiales.',
  },
  {
    title: 'Instalamos y rematamos',
    text: 'Colocación, rodapiés, perfiles, ajuste de puertas, limpieza y entrega final.',
  },
]

export const PACKS = [
  {
    name: 'Pack Suelo Esencial',
    text: 'Para quien quiere renovar el pavimento con una instalación limpia y bien resuelta.',
    includes: ['Suelo nuevo instalado', 'Rodapiés y perfiles', 'Remates y limpieza final'],
  },
  {
    name: 'Pack Suelo + Puertas',
    text: 'Para quien quiere que toda la vivienda se vea actual, no solo el suelo.',
    includes: [
      'Todo el Pack Esencial',
      'Puertas nuevas o lacadas',
      'Herrajes y ajustes finos',
    ],
    featured: true,
  },
  {
    name: 'Pack Piso Listo',
    text: 'Para propietarios que quieren renovar rápido una vivienda para vivir, alquilar o vender.',
    includes: ['Todo el Pack Suelo + Puertas', 'Pintura completa', 'Entrega lista para entrar'],
  },
]

export const GALLERY_ITEMS = [
  {
    title: 'Salón en L’Eixample',
    detail: 'Roble multicapa · 42 m² · rodapié lacado',
    before:
      'https://cdn.magicpatterns.com/patterns/generated-images/c3f6bb74-1c92-4589-9ec0-6ea73a8e3917.jpg',
    after:
      'https://cdn.magicpatterns.com/patterns/generated-images/c87f427e-16e6-409c-a97e-c76cdba452d2.jpg',
  },
  {
    title: 'Dormitorio en Gràcia',
    detail: 'Laminado premium · 18 m² · ajuste de 3 puertas',
    before:
      'https://cdn.magicpatterns.com/patterns/generated-images/1de381ef-d7b6-451f-b3de-0257840f6b11.jpg',
    after:
      'https://cdn.magicpatterns.com/patterns/generated-images/a664c308-6e65-4b02-ad5f-859aa63050c8.jpg',
  },
]

export const FAQS = [
  {
    q: '¿Puedo instalar suelo nuevo encima del actual?',
    a: 'En muchos casos sí. Si el suelo existente está firme, seco y sin desniveles importantes, se puede instalar encima, lo que evita obra y escombros. Antes de confirmarlo revisamos nivelación, humedad y altura disponible en puertas.',
  },
  {
    q: '¿Cuánto tarda la instalación?',
    a: 'Una vivienda media de 60–80 m² suele resolverse en 2 a 4 días de trabajo, incluyendo rodapiés y remates. Si hay retirada de suelo antiguo, autonivelado o ajuste de puertas, planificamos un día adicional y te lo indicamos en el presupuesto.',
  },
  {
    q: '¿El precio de la calculadora es final?',
    a: 'No. Es una estimación orientativa para que sepas el orden de inversión. El presupuesto cerrado se emite después de la revisión técnica, donde confirmamos metros reales, estado del soporte y acabados.',
  },
  {
    q: '¿También hacéis rodapiés y puertas?',
    a: 'Sí. Forman parte del Sistema Suelo Perfecto™: instalamos rodapiés y perfiles, y ajustamos o sustituimos puertas para que encajen con la nueva cota del suelo.',
  },
  {
    q: '¿Trabajáis solo en Barcelona ciudad?',
    a: 'Trabajamos en Barcelona ciudad y área metropolitana. Para otras zonas de Cataluña lo valoramos según el volumen del proyecto.',
  },
  {
    q: '¿Puedo enviar fotos por WhatsApp?',
    a: 'Sí, es la vía más rápida. Con fotos del suelo actual, rodapiés y puertas podemos orientarte antes de la visita técnica.',
  },
]
